import { render, staticRenderFns } from "./SharingEmbed.vue?vue&type=template&id=2c8aeb5f&scoped=true&lang=pug&"
import script from "./SharingEmbed.vue?vue&type=script&lang=js&"
export * from "./SharingEmbed.vue?vue&type=script&lang=js&"
import style0 from "./SharingEmbed.vue?vue&type=style&index=0&id=2c8aeb5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8aeb5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRadio,VRadioGroup,VRow,VSpacer})
